module.exports = __webpack_public_path__ + "static/media/pause.2eb18bc4.svg";